import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import useAuth from "../../Hooks/useAuth";
import { useNavigate } from "react-router";

import { API } from "../../utils/Apis";
import CustomButton from "../../Components/Button";
import { defaultAvailability } from "../../Constants";
import TagsInputList from "../../Components/TagsInputList";
import SpaceAvailability from "./SpaceAvailability";
import SpaceInfoStepFour from "./SpaceInfoStepFour";
import SpaceInfoStepFive from "./SpaceInfoStepFive";
import {
  getLocalData,
  removeLocalData,
  saveLocalData,
} from "../../utils/LocalStorage";
import { showToast } from "../../utils/helpers";
import { SpaceStepTypes, SpaceTypes } from "../../Constants/Interfaces";

const initSpace = {
  venueId: "",
  name: "",
  roomNumber: "",
  email: "",
  phone: "",
  capacity: "",
  status: "draft", // draft || published
  description: "",
  ratePerHour: "",
  minHours: "",
  discountHours: "",
  media: [],
  vibeTags: [],
  occassionTags: [],
  features: [],
  amenities: [],
  otherTags: [],
  availabilities: defaultAvailability,
};

const SpaceInfos: React.FC<SpaceStepTypes> = ({ venue, setStepBack }) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [data, setData] = useState<SpaceTypes>({
    ...initSpace,
  });

  const [errors, setErrors] = useState({
    name: "",
    roomNumber: "",
    capacity: "",
    vibeTags: "",
    occassionTags: "",
    featuresTags: "",
    amenitiesTags: "",
    otherTags: "",
    description: "",
    ratePerHour: "",
    minHours: "",
    discountHours: "",
  });

  const [loading, setLoading] = useState(false);
  const [spaceStep, setSpaceStep] = useState(1);
  const [spaceId, setSpaceId] = useState("");
  const [mediaOperations, setMediaOperations] = useState({
    delete: [],
    reorder: [],
  });

  const onChange = (field: string, value: any) => {
    setData({
      ...data,
      [field]: value,
    });
  };

  const stepBack = () => {
    if (spaceStep === 1) {
      setStepBack();
    } else {
      setSpaceStep((prev) => prev - 1);
    }
  };

  const validateSpace = () => {
    let isErrors = false;
    const errs = {
      name: "",
      roomNumber: "",
      capacity: "",
      vibeTags: "",
      occassionTags: "",
      description: "",
    };

    if (!data.name || data.name === "") {
      errs.name = "Please enter space name";
      isErrors = true;
    }

    if (!data.roomNumber || data.roomNumber === "") {
      errs.roomNumber = "Please enter room number";
      isErrors = true;
    }

    if (!data.capacity || data.capacity === "") {
      errs.capacity = "Please enter capacity for the room";
      isErrors = true;
    }

    // if (!data.vibeTags || data?.vibeTags.length === 0) {
    //   errs.vibeTags = "Please enter vibes";
    //   isErrors = true;
    // }

    // if (!data.occassionTags || data?.occassionTags.length === 0) {
    //   errs.occassionTags = "Please enter occasions";
    //   isErrors = true;
    // }

    if (!data.description || data.description === "") {
      errs.description = "Please enter occasions";
      isErrors = true;
    }

    setErrors({ ...errors, ...errs });

    return isErrors;
  };

  const saveSpace = (createNew = false) => {
    const isError = validateSpace();
    if (!isError) {
      setLoading(true);
      //
      if (!spaceId || spaceId === "") {
        const tempData = {
          venueId: venue.id,
          name: data.name,
          roomNumber: data.roomNumber,
          capacity: data.capacity,
          vibeTags: data.vibeTags,
          occassionTags: data.occassionTags,
          description: data.description,
        };

        API.createNewSpace(tempData)
          .then((res) => {
            if (res.type === "success") {
              saveLocalData("onBoardingSpaceID", res.data.id);

              setSpaceStep((prev) => prev + 1);
            }

            showToast(res.type, res.message);
          })
          .catch((err) => {
            showToast("error", err.message);
          })
          .finally(() => setLoading(false));
      } else {
        let tempData = {};
        if (spaceStep === 1) {
          tempData = {
            id: spaceId,
            name: data.name,
            roomNumber: data.roomNumber,
            capacity: data.capacity,
            vibeTags: data.vibeTags,
            occassionTags: data.occassionTags,
            description: data.description,
          };
        } else if (spaceStep === 2) {
          tempData = {
            id: spaceId,
            features: data.features,
            amenities: data.amenities,
            others: data.otherTags,
          };
        } else if (spaceStep === 3) {
          tempData = {
            id: spaceId,
            name: data.name,
          };
        } else if (spaceStep === 4) {
          tempData = {
            id: spaceId,
            ratePerHour: data.ratePerHour,
            minHours: data.minHours,
            discountHours: data.discountHours,
          };
        }

        if (spaceStep === 5) {
          tempData = {
            id: spaceId,
            name: data.name,
          };
        } else {
        }

        API.updateSpace(tempData)
          .then((res) => {
            const type = res.type === "success" ? "success" : "error";
            showToast(type, res.message);

            if (res.type === "success") {
              if (spaceStep === 5 && !createNew && user.type === "user") {
                navigate("/user/venues");

                removeLocalData("onBoardingSpaceID");
                removeLocalData("onBoardingVanueID");
              } else if (spaceStep === 5 && !createNew) {
                navigate("/admin");

                removeLocalData("onBoardingSpaceID");
                removeLocalData("onBoardingVanueID");
              } else if (spaceStep === 5 && createNew) {
                removeLocalData("onBoardingSpaceID");
                setData({ ...initSpace });
                setSpaceStep(1);
              } else {
                setSpaceStep((prev) => prev + 1);
              }
            }
          })
          .catch((err) => {
            showToast("error", err.message);
          })
          .finally(() => setLoading(false));
      }
    }
  };

  const updateLastSteps = (createNew = false) => {
    if (spaceStep === 5 && !createNew && user.type === "user") {
      navigate("/user/venues");

      removeLocalData("onBoardingSpaceID");
      removeLocalData("onBoardingVanueID");
    } else if (spaceStep === 5 && !createNew) {
      navigate("/admin");

      removeLocalData("onBoardingSpaceID");
      removeLocalData("onBoardingVanueID");
    } else if (spaceStep === 5 && createNew) {
      setSpaceStep(1);
      setData({ ...initSpace });
      removeLocalData("onBoardingSpaceID");
    }
  };

  const getHeadingTitle = () => {
    let title;
    if (spaceStep === 1) {
      title = "General Information";
    } else if (spaceStep === 2) {
      title = "Features";
    } else if (spaceStep === 3) {
      title = "Schedule";
    } else if (spaceStep === 4) {
      title = "Price";
    } else if (spaceStep === 5) {
      title = "Upload Image(s)";
    }
    return title;
  };

  const getSpaceInfo = () => {
    const spaceID = getLocalData("onBoardingSpaceID");

    if (spaceID) {
      setSpaceId(spaceID);

      API.getSpace(spaceID).then((res) => {
        if (res.type === "success") {
          setData({
            // ...data,
            ...res.data,
          });
        }
      });
    }
  };

  useEffect(() => {
    getSpaceInfo();
  }, []);

  console.log("venue :", mediaOperations);

  return (
    <>
      <div className="steps-headings">
        <div className="d-flex align-items-center">
          <span className="back-icon" onClick={() => stepBack()}>
            <i className="fas fa-chevron-left" />
          </span>
          <h2>Tell us about your space one in the {venue && venue.name}</h2>
        </div>

        <div className="steps-sub-heading">
          <h3>{getHeadingTitle()}</h3>
          <h3>({spaceStep}/5)</h3>
        </div>
      </div>

      <div className="">
        {spaceStep === 1 && (
          <>
            <p className="required-note">
              <span className="required-star">*</span> Required
            </p>
            <div className="row">
              <div className="col-md-6 col-sm-6 col-xs-12">
                <div className="form-group">
                  <label>
                    Space name<span className="required-star">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="e.g. Main Conference Room"
                    name="name"
                    value={data.name}
                    onChange={(e) => onChange("name", e.target.value)}
                  />
                  {errors.name && <span className="error">{errors.name}</span>}
                </div>
              </div>

              <div className="col-md-6 col-sm-6 col-xs-12">
                <div className="form-group">
                  <label>
                    Room number<span className="required-star">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="e.g. 204 or Suite B"
                    name="roomNumber"
                    value={data.roomNumber}
                    onChange={(e) => onChange("roomNumber", e.target.value)}
                  />
                  {errors.roomNumber && (
                    <span className="error">{errors.roomNumber}</span>
                  )}
                </div>
              </div>
            </div>

            <div className="form-group">
              <label>
                Capacity<span className="required-star">*</span>
              </label>

              <input
                type="number"
                className="form-control"
                placeholder="Number of guests"
                name="capacity"
                value={data.capacity}
                onChange={(e) => onChange("capacity", e.target.value)}
              />
              {errors.capacity && (
                <span className="error">{errors.capacity}</span>
              )}
            </div>

            <TagsInputList
              label="Vibes"
              items={data.vibeTags}
              updateTags={(items: any) => onChange("vibeTags", items)}
              error={errors.vibeTags}
            />

            <TagsInputList
              label="Occasions"
              items={data.occassionTags}
              updateTags={(items: any) => onChange("occassionTags", items)}
              error={errors.occassionTags}
            />

            <div className="form-group">
              <label>
                Description<span className="required-star">*</span>
              </label>

              <textarea
                rows={5}
                className="form-control"
                placeholder="Describe the space, its layout, and what makes it special"
                name="description"
                onChange={(e) => onChange("description", e.target.value)}
                value={data.description}
              />
              {errors.description && (
                <span className="error">{errors.description}</span>
              )}
            </div>
          </>
        )}

        {spaceStep === 2 && (
          <>
            <TagsInputList
              field="features"
              type="Space"
              label="Add your space features"
              items={data.features}
              updateTags={(items: any) => onChange("features", items)}
              error={errors.featuresTags}
            />

            <TagsInputList
              field="amenities"
              type="Space"
              label="Add your space amenities"
              items={data.amenities}
              updateTags={(items: any) => onChange("amenities", items)}
              error={errors.amenitiesTags}
            />

            <TagsInputList
              field="other"
              type="Space"
              label="Add other tags for your space"
              items={data.otherTags}
              updateTags={(items: any) => onChange("otherTags", items)}
              error={errors.otherTags}
            />
          </>
        )}

        {spaceStep === 3 && (
          <SpaceAvailability
            spaceId={data.id}
            availabilities={data.availabilities}
            onChange={(temAvailability: any) =>
              onChange("availabilities", temAvailability)
            }
          />
        )}

        {spaceStep === 4 && (
          <SpaceInfoStepFour
            space={data}
            setStepBack={stepBack}
            onChange={(field: string, value: string) => onChange(field, value)}
          />
        )}

        {spaceStep === 5 && (
          <SpaceInfoStepFive
            spaceId={spaceId}
            media={data.media}
            updateMedia={(newItems: object) =>
              setData({ ...data, [media]: newItems })
            }
            mediaOperations={mediaOperations}
            setMediaOperations={setMediaOperations}
            updateLastSteps={updateLastSteps}
            isOnBoarding={true}
          />
        )}
      </div>

      {spaceStep !== 5 && (
        <div className="navigation-btns">
          {spaceStep !== 1 && (
            <Button className="skip-btn" onClick={() => {}}>
              Skip
            </Button>
          )}

          <div className="nav-btn-group">
            <CustomButton
              isLoading={loading}
              title={"Continue"}
              onClick={() => saveSpace()}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default SpaceInfos;
